<template>
  <refresh type="pool">
    <div class="gift-icon">
      <div class="refresh-icon"></div>
    </div>
  </refresh>
</template>
<script>
  import Refresh from '@/components/refresh/refresh'
  export default {
    name: 'PoolRefresh',
    components: {
      Refresh
    },
    data() {
      return {}
    }
  }
</script>
<style lang="scss">
  .gift-icon {
    position: absolute;
    top: 50%;
    left: 50%;
    @include px2res(margin-top, -5);
    @include px2res(width, 124);
    @include px2res(height, 123);
    transform: translate(-50%, -50%);
  }
  .refresh-icon {
    position: absolute;
    @include px2res(bottom, 18);
    @include px2res(right, 0);
    @include px2res(width, 42);
    @include px2res(height, 42);
    animation: icon_skew 10s ease-in-out 2s infinite;
  }
</style>


// WEBPACK FOOTER //
// src/components/pool-refresh/pool-refresh.vue